"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IrisElement = void 0;
class IrisElement {
    constructor(containerID) {
        this.containerID = 'IRIS-WEB-CONTAINER';
        this.containerDisplay = 'none';
        if (containerID) {
            this.containerID = containerID;
        }
    }
    createIrisElement() {
        const dom = document.createElement('div');
        dom.id = this.containerID;
        this.containerElement = dom;
        return dom;
    }
    getIrisElement() {
        return this.containerElement;
    }
    remove() {
        var _a;
        (_a = this.containerElement) === null || _a === void 0 ? void 0 : _a.remove();
    }
    release() {
        this.remove();
    }
}
exports.IrisElement = IrisElement;
